import { useParams,useLocation  } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { useReactToPrint } from 'react-to-print'
import { FileDown, FileSignature } from 'lucide-react'
import { Link } from 'react-router-dom'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { useArtworkOrder } from 'store/server/useOrder'
import useOrderStore from 'store/client/orderStore'
import html2pdf from 'html2pdf.js'
import { useCreatePDF } from 'store/server/useOrder'
import { Button } from 'components/ui/button'
import Spinner from 'components/spinner'
import L60_25 from './L60_25'
import L60_30 from './L60_30'
import domtoimage from 'dom-to-image';
import L60_40 from './L60_40'
import L120_25 from './L120_25'
import AllRoutes from 'Routes'
import Warning_55_120 from './Warning_55_120'
import L55XPR from './Price/index'
import L55XPRKNIFE from './PriceKnife/index'
import BeltMain from '../ArtWork2/Belt/İndex'
import BeltMainHome from '../ArtWork2/BeltHome/İndex'
import BeltKnifeMain from '../ArtWork2/BeltKnife/İndex'
import BrandMain from '../ArtWork2/Brand/İndex'
import BrandMainZaraHome from '../ArtWork2/BrandZaraHome/İndex'
import CordMain from '../ArtWork2/Cord/İndex'
import AddionalMain from '../ArtWork2/Addional/İndex'
import EmptyMain from '../ArtWork2/Empty/İndex'
import L120_25New from './L120_25New'
import L55XPRH from './PriceHome/index'
import L55XPRHOMEH from './PriceHomeKnife/index'
import Label11Dynamic from './ZaraHomeLabel11/index'
import Label12Dynamic from './ZaraHomeLabel12/index'
import EkstraMain from './EkstraKartı/İndex'
// === IMPORTLAR (src/assets/fonts altından) ===
// Yol notu: dosyanız src/ altında neredeyse oraya göre ../ sayısını ayarlayın.
// Örn. bu dosya src/ kökünde ise "../../../../assets/..." yapın.

import PdfSafeWoff2 from '../../../../assets/fonts/arial-unicode-ms.woff2';
import ArialUnicodeMSOtf from '../../../../assets/fonts/arialunicodems.otf';

// Helvetica Neue LT Std / Pro ve türevleri
import HelveticaNeueLTStdCnWoff2 from '../../../../assets/fonts/wooffonts/HelveticaNeueLTStd-Cn.woff2';
import HelveticaLTStdRomanWoff2 from '../../../../assets/fonts/wooffonts/HelveticaLTStd-Roman.woff2';
import HelveticaNeueLTStdMdWoff2 from '../../../../assets/fonts/wooffonts/HelveticaNeueLTStd-Md.woff2';
import HelveticaNeueLTStdBdWoff2 from '../../../../assets/fonts/wooffonts/HelveticaNeueLTStd-Bd.woff2';

import HelveticaNeueLTProMdWoff2 from '../../../../assets/fonts/wooffonts/HelveticaNeueLTPro-Md.woff2';
import HelveticaNeueLTProHvWoff2 from '../../../../assets/fonts/wooffonts/HelveticaNeueLTPro-Hv.woff2';

import HelveticaNeueLT57CnWoff2 from '../../../../assets/fonts/helvetica/HelveticaNeueLT-57Cn.woff2';
import HelveticaNeueLT77BdCnWoff2 from '../../../../assets/fonts/helvetica/HelveticaNeueLT-77BdCn.woff2';
import HelveticaNeueLTProMdCnWoff2 from '../../../../assets/fonts/helvetica/HelveticaNeueLTPro-MdCn.woff2';
import HelveticaNeueLTProBdCnWoff2 from '../../../../assets/fonts/helvetica/HelveticaNeueLTPro-BdCn.woff2';

// Helvetica Narrow
import HelveticaNarrowBoldWoff2 from '../../../../assets/fonts/Helvetica-Narrow-Bold.woff2';
// Arial Narrow
import ArialNarrowWoff2 from '../../../../assets/fonts/wooffonts/ArialNarrow.woff2';
import ArialNarrowBoldWoff2 from '../../../../assets/fonts/wooffonts/ArialNarrow-Bold.woff2';

// ZaraH1Sans ailesi
import ZaraH1SansLightWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-Light.woff2';
import ZaraH1SansBoldWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-Bold.woff2';
import ZaraH1SansLightItalicWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-LightItalic.woff2';
import ZaraH1SansMediumItalicWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-MediumItalic.woff2';
import ZaraH1SansExtraLightItalicWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-ExtraLightItalic.woff2';
import ZaraH1SansExtraLightWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-ExtraLight.woff2';
import ZaraH1SansMediumWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-Medium.woff2';
import ZaraH1SansBoldItalicWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-BoldItalic.woff2';
import ZaraH1SansSemiBoldWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-SemiBold.woff2';
import ZaraH1SansThinItalicWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-ThinItalic.woff2';
import ZaraH1SansRegularItalicWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-RegularItalic.woff2';
import ZaraH1SansSemiBoldItalicWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-SemiBoldItalic.woff2';
import ZaraH1SansThinWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-Thin.woff2';
import ZaraH1SansRegularWoff2 from '../../../../assets/fonts/zarah1sans/ZaraH1Sans-Regular.woff2';

// Arial TTF ailesi
import ArialRegularTtf from '../../../../assets/fonts/arial/ARIAL.TTF';
import ArialBoldTtf from '../../../../assets/fonts/arial/ARIALBD.TTF';
import ArialBoldItalicTtf from '../../../../assets/fonts/arial/ARIALBI.TTF';
import ArialItalicTtf from '../../../../assets/fonts/arial/ARIALI.TTF';
import ArialBlackTtf from '../../../../assets/fonts/arial/ARIBLK.TTF';
import ArialNarrowTtf from '../../../../assets/fonts/arial/ARIALN.TTF';
import ArialNarrowItalicTtf from '../../../../assets/fonts/arial/ARIALNI.TTF';
import ArialNarrowBoldItalicTtf from '../../../../assets/fonts/arial/ARIALNBI.TTF';


// // İsteğe bağlı Roboto (örnek)
// import RobotoRegularWoff2 from '../assets/fonts/roboto/Roboto-Regular.woff2';
// import RobotoBoldWoff2 from '../assets/fonts/roboto/Roboto-Bold.woff2';



export const PRINT_FONTS = [
  // ---- Unicode / fallback ----
  {
    family: 'PdfSafe',
    source: `url('${PdfSafeWoff2}') format('woff2')`,
    style: 'normal',
    weight: '400',
  },
  {
    family: 'Arial Unicode MS',
    source: `url('${ArialUnicodeMSOtf}') format('opentype')`,
    style: 'normal',
    weight: '400',
  },

  // ---- Helvetica Neue LT Std (Std/Pro karışmasın) ----
  {
    family: 'Helvetica Neue LT Std',
    source: `url('${HelveticaNeueLTStdCnWoff2}') format('woff2')`,
    style: 'normal',
    weight: '400',
  },
  {
    family: 'Helvetica Neue LT Std Roman',
    source: `url('${HelveticaLTStdRomanWoff2}') format('woff2')`,
    style: 'normal',
    weight: '400',
  },
  {
    family: 'Helvetica Neue LT Std Medium',
    source: `url('${HelveticaNeueLTStdMdWoff2}') format('woff2')`,
    style: 'normal',
    weight: '500',
  },
  {
    family: 'Helvetica Neue LT Std Bold',
    source: `url('${HelveticaNeueLTStdBdWoff2}') format('woff2')`,
    style: 'normal',
    weight: '700',
  },

  // ---- Helvetica Neue LT Pro ailesi ----
  {
    family: 'HelveticaNeueLTPro-Md',
    source: `url('${HelveticaNeueLTProMdWoff2}') format('woff2')`,
    style: 'normal',
    weight: '500',
  },
  {
    family: 'HelveticaNeueLTPro',
    source: `url('${HelveticaNeueLTProHvWoff2}') format('woff2')`,
    style: 'normal',
    weight: '500',
  },
  {
    family: 'HelveticaNeueLT57Condensed',
    source: `url('${HelveticaNeueLT57CnWoff2}') format('woff2')`,
    style: 'normal',
    weight: '500',
  },
  {
    family: 'HelveticaNeueLT77BoldCondensed',
    source: `url('${HelveticaNeueLT77BdCnWoff2}') format('woff2')`,
    style: 'normal',
    weight: '700',
  },
  {
    family: 'HelveticaNeueLTPro-MdCn',
    source: `url('${HelveticaNeueLTProMdCnWoff2}') format('woff2')`,
    style: 'normal',
    weight: '500',
  },
  {
    family: 'HelveticaNeueLTPro-BdCn',
    source: `url('${HelveticaNeueLTProBdCnWoff2}') format('woff2')`,
    style: 'normal',
    weight: '700',
  },

  // ---- Helvetica Narrow ----
  {
    family: 'HelveticaNarrowBold',
    source: `url('${HelveticaNarrowBoldWoff2}') format('woff2')`,
    style: 'normal',
    weight: '700',
  },

  // ---- Arial Narrow ----
  {
    family: 'ArialNarrow',
    source: `url('${ArialNarrowWoff2}') format('woff2')`,
    style: 'normal',
    weight: '400',
  },
  {
    family: 'ArialNarrowBold',
    source: `url('${ArialNarrowBoldWoff2}') format('woff2')`,
    style: 'normal',
    weight: '700',
  },

  // ---- ZaraH1Sans (tüm varyantlar) ----
  {
    family: 'ZaraH1Sans-Light',
    source: `url('${ZaraH1SansLightWoff2}') format('woff2')`,
    style: 'normal',
    weight: '300',
  },
  {
    family: 'ZaraH1Sans-Bold',
    source: `url('${ZaraH1SansBoldWoff2}') format('woff2')`,
    style: 'normal',
    weight: '700',
  },
  {
    family: 'ZaraH1Sans-LightItalic',
    source: `url('${ZaraH1SansLightItalicWoff2}') format('woff2')`,
    style: 'italic',
    weight: '300',
  },
  {
    family: 'ZaraH1Sans-MediumItalic',
    source: `url('${ZaraH1SansMediumItalicWoff2}') format('woff2')`,
    style: 'italic',
    weight: '500',
  },
  {
    family: 'ZaraH1Sans-ExtraLightItalic',
    source: `url('${ZaraH1SansExtraLightItalicWoff2}') format('woff2')`,
    style: 'italic',
    weight: '200',
  },
  {
    family: 'ZaraH1Sans-ExtraLight',
    source: `url('${ZaraH1SansExtraLightWoff2}') format('woff2')`,
    style: 'normal',
    weight: '200',
  },
  {
    family: 'ZaraH1Sans-Medium',
    source: `url('${ZaraH1SansMediumWoff2}') format('woff2')`,
    style: 'normal',
    weight: '500',
  },
  {
    family: 'ZaraH1Sans-BoldItalic',
    source: `url('${ZaraH1SansBoldItalicWoff2}') format('woff2')`,
    style: 'italic',
    weight: '700',
  },
  {
    family: 'ZaraH1Sans-SemiBold',
    source: `url('${ZaraH1SansSemiBoldWoff2}') format('woff2')`,
    style: 'normal',
    weight: '600',
  },
  {
    family: 'ZaraH1Sans-ThinItalic',
    source: `url('${ZaraH1SansThinItalicWoff2}') format('woff2')`,
    style: 'italic',
    weight: '100',
  },
  {
    family: 'ZaraH1Sans-RegularItalic',
    source: `url('${ZaraH1SansRegularItalicWoff2}') format('woff2')`,
    style: 'italic',
    weight: '400',
  },
  {
    family: 'ZaraH1Sans-SemiBoldItalic',
    source: `url('${ZaraH1SansSemiBoldItalicWoff2}') format('woff2')`,
    style: 'italic',
    weight: '600',
  },
  {
    family: 'ZaraH1Sans-Thin',
    source: `url('${ZaraH1SansThinWoff2}') format('woff2')`,
    style: 'normal',
    weight: '100',
  },
  {
    family: 'ZaraH1Sans-Regular',
    source: `url('${ZaraH1SansRegularWoff2}') format('woff2')`,
    style: 'normal',
    weight: '400',
  },

  // ---- Arial TTF ----
  {
    family: 'Arial-Regular',
    source: `url('${ArialRegularTtf}') format('truetype')`,
    style: 'normal',
    weight: '400',
  },
  {
    family: 'Arial-Bold',
    source: `url('${ArialBoldTtf}') format('truetype')`,
    style: 'normal',
    weight: '700',
  },
  {
    family: 'Arial-BoldItalic',
    source: `url('${ArialBoldItalicTtf}') format('truetype')`,
    style: 'italic',
    weight: '700',
  },
  {
    family: 'Arial-Italic',
    source: `url('${ArialItalicTtf}') format('truetype')`,
    style: 'italic',
    weight: '400',
  },
  {
    family: 'Arial-Black',
    source: `url('${ArialBlackTtf}') format('truetype')`,
    style: 'normal',
    weight: '900',
  },
  {
    family: 'Arial-Narrow',
    source: `url('${ArialNarrowTtf}') format('truetype')`,
    style: 'normal',
    weight: '400',
  },
  {
    family: 'Arial-NarrowItalic',
    source: `url('${ArialNarrowItalicTtf}') format('truetype')`,
    style: 'italic',
    weight: '400',
  },
  {
    family: 'Arial-NarrowBoldItalic',
    source: `url('${ArialNarrowBoldItalicTtf}') format('truetype')`,
    style: 'italic',
    weight: '700',
  },

  // ---- (Opsiyonel) Roboto ----
  // {
  //   family: 'Roboto',
  //   source: `url('${RobotoRegularWoff2}') format('woff2')`,
  //   style: 'normal',
  //   weight: '400',
  // },
  // {
  //   family: 'Roboto',
  //   source: `url('${RobotoBoldWoff2}') format('woff2')`,
  //   style: 'normal',
  //   weight: '700',
  // },
];
const parseUrlFromSource = (source /* : string */) => {
  const m = source.match(/url\((['"]?)(.*?)\1\)/i);
  return m?.[2] ?? '';
};

// --- yardımcılar ---
const wait = (ms) => new Promise(res => setTimeout(res, ms));

async function waitForImages(root, timeoutMs = 20000) {
  const imgs = Array.from(root.querySelectorAll('img'));
  const toLoad = imgs.filter(img => !img.complete || img.naturalWidth === 0);

  if (toLoad.length === 0) return;

  await Promise.race([
    Promise.all(
      toLoad.map(
        img =>
          new Promise(resolve => {
            const done = () => resolve();
            img.addEventListener('load', done, { once: true });
            img.addEventListener('error', done, { once: true });
          })
      )
    ),
    wait(timeoutMs),
  ]);
}

async function waitForFonts(fontFamilies, timeoutMs = 25000) {
  if (!('fonts' in document)) return;
  const loads = fontFamilies.map(f => {
    // Ağırlık/biçim kombinasyonlarına da şans verelim
    return Promise.allSettled([
      document.fonts.load(`400 14px "${f}"`, 'ABCxyz 123₺'),
      document.fonts.load(`700 14px "${f}"`, 'ABCxyz 123₺'),
      document.fonts.load(`italic 14px "${f}"`, 'ABCxyz 123₺'),
    ]);
  });
  await Promise.race([Promise.all(loads), wait(timeoutMs)]);
  if (document.fonts?.ready) {
    await Promise.race([document.fonts.ready, wait(5000)]);
  }
}

async function verifyAndLoadFonts(fonts /* : Array<{family:string; source:string; style?:string; weight?:string;}> */) {
  const failures /* : Array<{ family: string; url: string; error: unknown }> */ = [];
  const loadedFonts = new Set();

  // Font yükleme işlemini batch'ler halinde yap - daha küçük batch
  const batchSize = 2; // Batch size'ı daha da küçülttük
  for (let i = 0; i < fonts.length; i += batchSize) {
    const batch = fonts.slice(i, i + batchSize);
    
    await Promise.allSettled(
      batch.map(async (font) => {
        if (loadedFonts.has(font.family)) return;
        
        try {
          // Font zaten yüklenmiş mi kontrol et
          const existingFont = Array.from(document.fonts).find(f => f.family === font.family);
          if (existingFont) {
            loadedFonts.add(font.family);
            return;
          }

          const ff = new FontFace(font.family, font.source, {
            style: font.style || 'normal',
            weight: font.weight || '400',
            display: 'swap' // Font yüklenirken fallback göster
          });
          
          // Font yükleme timeout'unu kısalt
          const loadPromise = ff.load();
          const timeoutPromise = new Promise((_, reject) => 
            setTimeout(() => reject(new Error('Font yükleme timeout')), 5000) // 5 saniye timeout
          );
          
          await Promise.race([loadPromise, timeoutPromise]);
          document.fonts.add(ff);
          loadedFonts.add(font.family);
          
          console.log(`✅ Font yüklendi: ${font.family}`);
        } catch (err) {
          console.warn(`❌ Font yükleme hatası: ${font.family}`, err);
          failures.push({ family: font.family, url: parseUrlFromSource(font.source), error: err });
        }
      })
    );
    
    // Her batch arasında kısa bekleme
    await new Promise(resolve => setTimeout(resolve, 100));
  }

  // Font ready bekleme süresini kısalt
  if (document.fonts && document.fonts.ready) {
    try {
      await Promise.race([
        document.fonts.ready,
        wait(5000) // 5 saniye timeout
      ]);
      console.log('🎉 Fontlar hazır');
      
    } catch (err) {
      console.warn('Font ready hatası:', err);
    }
  }

  return failures;
}


// <-- kapanış eklendi
// -----
export default function ArtWork2() {
  const { orderNo } = useParams();
  const location = useLocation();
  const [tab, setTab] = useState(null);
  const [zaratype, setZaratype] = useState(null);
  const [fontFailures, setFontFailures] = useState([]);
  const [isLoadingFonts, setIsLoadingFonts] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  // PRINT_FONTS içindeki family isimleri:
  const FONT_FAMILIES = PRINT_FONTS.map(f => f.family);

  const [gottypeprice, setGottypeprice] = useState(null);
  const [selectColor, setSelectColor] = useState(0);
  const [pageStyle, setPageStyle] = useState('@page { size: portrait; }');
  const componentRef = useRef(null);
  const { data, isFetching, error: artworkError, isError } = useArtworkOrder(
    orderNo, 
    tab, 
    zaratype,
    { enabled: tab !== null }
  );



  const { setReferance } = useOrderStore();
  const [bicakIziParams, setBicakIziParams] = useState(null); 
  const { mutate: createPDF, data: pdfUrl, isLoading, error: pdfError } = useCreatePDF()

  // print butonunun handler'ı - Optimize edilmiş versiyon
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Etiket_${orderNo}_${new Date().toISOString().split('T')[0]}`,
    removeAfterPrint: true,
    copyStyles: true,
    pageStyle: `
      ${pageStyle}
      @page { margin: 0; }
      @media print {
        html, body { margin:0 !important; padding:0 !important; width:100% !important; height:100% !important; }
        * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
      }
    `,
    onBeforeGetContent: async () => {
      setIsPrinting(true);
      setIsLoadingFonts(true);
      
      try {
        // Sadece kritik fontları yükle (tüm fontları değil)
        const criticalFonts = PRINT_FONTS.filter(font => 
          font.family.includes('Arial') || 
          font.family.includes('ZaraH1Sans') || 
          font.family.includes('Helvetica')
        );
        
        // Font yükleme timeout'unu kısalt
        await Promise.race([
          verifyAndLoadFonts(criticalFonts),
          wait(10000) // 10 saniye timeout
        ]);
        
        // Görselleri hızlıca bekle
        if (componentRef.current) {
          await Promise.race([
            waitForImages(componentRef.current, 5000), // 5 saniye timeout
            wait(5000)
          ]);
        }

        // Layout stabilizasyonu
        await new Promise(resolve => {
          requestAnimationFrame(() => resolve());
        });
        
        await wait(200); // Kısa bekleme
        setIsLoadingFonts(false);
        
      } catch (error) {
        console.warn('Font yükleme hatası, devam ediliyor:', error);
        setIsLoadingFonts(false);
      }
    },
    onAfterGetContent: async () => {
      try {
        // iframe kontrolü
        const iframe = document.querySelector('iframe[title="react-to-print"]');
        if (!iframe || !iframe.contentDocument) return;
        
        const doc = iframe.contentDocument;
        
        // Sadece temel font stillerini ekle
        const basicFontCss = `
          @font-face{font-family:'Arial-Regular';src:url('${ArialRegularTtf}') format('truetype');font-weight:400;font-style:normal;}
          @font-face{font-family:'Arial-Bold';src:url('${ArialBoldTtf}') format('truetype');font-weight:700;font-style:normal;}
          @font-face{font-family:'ZaraH1Sans-Regular';src:url('${ZaraH1SansRegularWoff2}') format('woff2');font-weight:400;font-style:normal;}
          @font-face{font-family:'ZaraH1Sans-Bold';src:url('${ZaraH1SansBoldWoff2}') format('woff2');font-weight:700;font-style:normal;}
        `;
        
        const styleEl = doc.createElement('style');
        styleEl.textContent = basicFontCss;
        doc.head.appendChild(styleEl);
        
        // Kısa font bekleme
        await Promise.race([
          doc.fonts?.ready || Promise.resolve(),
          wait(3000) // 3 saniye timeout
        ]);
        
      } catch (error) {
        console.warn('iframe font yükleme hatası:', error);
      }
    },
    onAfterPrint: () => {
      setIsPrinting(false);
    },
    onPrintError: (err) => {
      console.error('Print hatası:', err);
      setIsPrinting(false);
      alert('Print işlemi başarısız oldu. Alternatif Print butonunu kullanın.');
    },
  });


  useEffect(() => {
    console.log("Font yükleme hataları:", fontFailures);
    
    // Font durumunu debug et
    if (fontFailures.length > 0) {
      console.group('🔍 Font Debug Bilgileri');
      console.log('Başarısız fontlar:', fontFailures.map(f => f.family));
      console.log('Yüklenen fontlar:', Array.from(document.fonts).map(f => f.family));
      console.log('Toplam font sayısı:', document.fonts.size);
      console.groupEnd();
    }
  }, [fontFailures]);

  // Component mount olduğunda sadece kritik fontları yükle
  useEffect(() => {
    const preloadCriticalFonts = async () => {
      try {
        console.log('Kritik fontlar yükleniyor...');
        
        // Sadece en kritik fontları yükle
        const criticalFonts = PRINT_FONTS.filter(font => 
          font.family.includes('Arial-Regular') || 
          font.family.includes('Arial-Bold') ||
          font.family.includes('ZaraH1Sans-Regular') ||
          font.family.includes('ZaraH1Sans-Bold')
        );
        
        await Promise.race([
          verifyAndLoadFonts(criticalFonts),
          wait(8000) // 8 saniye timeout
        ]);
        
        console.log('Kritik fontlar yüklendi');
        
      } catch (error) {
        console.warn('Kritik font yükleme hatası:', error);
      }
    };
    
    // Sayfa yüklendikten sonra kritik fontları yükle
    setTimeout(preloadCriticalFonts, 500);
  }, []);


  // URL'den parametreleri al
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get('tab');
    const newTab = tabParam ? parseInt(tabParam, 10) : null;
    const gottypeprice = queryParams.get('gottype');
    const zaratypex = queryParams.get('zaratype');
    console.log("Tab parametresi:", { tabParam, newTab, location: location.search });
    setGottypeprice(gottypeprice);
    setTab(newTab);
    setZaratype(zaratypex);

    // Bıçak izi parametrelerini işle
    if (gottypeprice === 'man') {
      const totalParams = queryParams.get('totalParams');
      if (totalParams) {
        const totalParamsNum = parseInt(totalParams, 10);
        const params = [];
        
        // Tüm parametreleri bir array içinde topla
        for (let i = 0; i < totalParamsNum; i++) {
          const sizename = queryParams.get(`sizename${i}`);
          const count = queryParams.get(`count${i}`);
          const sizeCode = queryParams.get(`sizecode${i}`);

          if (sizename && count) {
            params.push({
              sizeCode: sizeCode,
              type: sizename,
              value: parseInt(count, 10)
            });
          }
        }
        
        // Parametreleri state'e kaydet
        if (params.length > 0) {
          setBicakIziParams(params);
        }
      }
    }
  }, [location.search]);

  // Data geldiğinde referans bilgilerini ayarla ve sayfa stilini güncelle
  useEffect(() => {
 
    if (!data || !data.referance) {
      return;
    }

    // Referans bilgilerini kullan
    setReferance(data.referance);

    // Tab değiştiğinde sayfa stilini ayarla
    if (tab !== null) {
      changedata(tab);
    }
  }, [data, tab]);




  const changedata = (tab) => {
    let newPageStyle = ( tab === 3 || tab === 2 ) ? '@page { size: landscape; margin: 0; }' : '@page { size: portrait; margin: 0; }';

    if(zaratype === "ZaraHome"){
      if(tab === 2){
        newPageStyle = `@page { size: portrait; margin: 0; }`;
        if(data && data.referance && (data.referance.code.includes("LABEL 10 280X70") || data.referance.code.includes("LABEL 10 KIDS 115x136"))){
          newPageStyle = `@page { size: landscape; margin: 0; }`;
        }
        else if (data && data.referance && (data.referance.code.includes("LABEL 10 388X70") || data.referance.code.includes("LABEL 10 320X70") || data.referance.code.includes("LABEL 10 320X45"))) {
          // Yükseklik A4 (297mm), genişlik ~400mm
          newPageStyle = `@page { size: 400mm 297mm; margin: 0; }`;
        }
      
      }
      if(tab===0 && data.companyId==='6562742a5b252fdddcc588e9' ){
   
        newPageStyle = `@page { size: landscape; margin: 0; }`;
      }
    }

    if(gottypeprice){
      if(tab === 2) {
        newPageStyle = `@page { size: 30cm 45cm; margin: 0; }`;
        if(zaratype === "ZaraHome"){
          newPageStyle = `@page { size: 35cm 33.3cm; margin: 0; }`;
        }
        if(data && data.referance && data.referance.width === 95){
          newPageStyle = `@page { size: 45cm 30cm; margin: 0; }`;
        }
      }
      if(tab === 3){
        newPageStyle = `@page { size: 50cm 35cm; margin: 0; }`;
      }
    }
    else if (data && data.referance && data.referance.code.includes("LABEL 12")) {
      newPageStyle = `
        @page {
          size: 210mm 297mm;
          margin: 0;
        }

        @media print {
          body {
            zoom: 150%;
            -webkit-transform-origin: top left;
            transform-origin: top left;
          }
        }
      `;
    }

    setPageStyle(newPageStyle);
  }
  if (isFetching) {
    return <Spinner className="h-screen w-5" />;
  }
  function applyMarginTopToElements(element) {
    // `.mt-1` sınıfını içeren tüm elementleri seç
    const elements = element.querySelectorAll('.mt-1')

    // Her bir element için marginTop stilini ayarla
    elements.forEach((el) => {
      el.style.marginTop = '0.25rem'
    })
  }

  async function exportPDF() {
    await document.fonts.ready;
  
    const element = componentRef.current;
    element.style.padding = '0';
    element.style.margin = '0';
    const orientation = labelWidth === 120 ? 'landscape' : 'portrait';
    const startYPosition = 0; // Yükseklik başlangıç noktası
  
    // Özel stilleri ekleyin
    const style = document.createElement('style');
    style.innerHTML = `
      .margo { margin-top: -2px !important; }
      .dargo { margin-top: -5px !important; }
      .bottor { margin-bottom: 4px !important; }
      .zargo { margin-top: -8px !important; }
      .kargo { margin-top: 4px !important; }
      .mard { margin-top: -2px !important; margin-left: -4px !important; }
    `;
    document.head.appendChild(style);
  
    // HTML elementini SVG'ye dönüştür
   /* domtoimage.toSvg(element)
      .then(function (dataUrl) {
        var svg = atob(dataUrl.substring('data:image/svg+xml;base64,'.length));
        var doc = new jsPDF({
          orientation: orientation,
          unit: 'mm',
          format: 'a4',
          compressPDF: true
        });
  
        doc.addSVG(svg, 0, 0, 210, 297); // SVG'yi PDF'e ekleyin
        doc.save('document.pdf'); // PDF dosyasını kaydedin
      })
      .catch(function (error) {
        console.error('SVG dönüşümünde hata oluştu', error);
      })
      .finally(() => {
        document.head.removeChild(style); // Özel stilleri kaldır
      });
      */
  }

  async function exportPDFWithMultiplePages() {
    const element = componentRef.current; // PDF'e dönüştürmek istediğiniz element
    const orientation = 'portrait'; // Veya 'landscape'
    const format = 'a4'; // Sayfa boyutu
    
    // jsPDF nesnesini oluştur
    const pdf = new jsPDF({
      orientation,
      unit: 'mm',
      format,
    });
  
    // İçeriği sayfa sayfa işleyin (Örnek olarak 1 sayfa gösterilmektedir, döngü ile sayfa sayısı artırılabilir)
    html2canvas(element, { scale: 2 }).then(canvas => {
      // Canvas'tan resim URL'si oluştur
      const imgData = canvas.toDataURL('image/png');
  
      // Resmi PDF'e ekle
      pdf.addImage(imgData, 'PNG', 0, 0, pdf.internal.pageSize.getWidth()*2, pdf.internal.pageSize.getHeight()*2);
  
      // Eğer daha fazla sayfa varsa 'addPage' metodu ile yeni sayfa ekleyin ve işlemi tekrarlayın
      // pdf.addPage();
  
      // PDF'i kaydet
      pdf.save('document.pdf');
    });
  }
  const handleCreatePDF = () => {
    if (componentRef.current) {
      const htmlContent = componentRef.current.outerHTML
      const pdfData = { content: htmlContent, orientation: 'portrait' } // PDF verisi
      createPDF(pdfData) // PDF oluşturma işlemini tetikle
    }
  }

  // Loading Indicator Component
  const LoadingIndicator = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 shadow-2xl max-w-md mx-4">
        <div className="text-center">
          {/* Spinner Animation */}
          <div className="relative mb-6">
            <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-8 h-8 border-2 border-blue-300 border-t-blue-700 rounded-full animate-spin"></div>
            </div>
          </div>
          
          {/* Loading Text */}
          <h3 className="text-xl font-semibold text-gray-800 mb-2">
            Pdf Hazırlanıyor
          </h3>
          <p className="text-gray-600 mb-4">
            Lütfen bekleyin, pdf hazırlanıyor...
          </p>
          
          {/* Progress Bar */}
          <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
            <div className="bg-gradient-to-r from-blue-500 to-purple-600 h-2 rounded-full animate-pulse" 
                 style={{width: '70%'}}></div>
          </div>
          
          {/* Loading Dots */}
          <div className="flex justify-center space-x-1">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
          </div>
        </div>
      </div>
    </div>
  );

  // Alternatif print fonksiyonu
  const handleAlternativePrint = async () => {
    try {
      // Loading indicator'ı göster
      setIsLoadingFonts(true);
      
      if (!componentRef.current) {
        alert('Print edilecek içerik bulunamadı');
        return;
      }

      // Fontları yükle
      await verifyAndLoadFonts(PRINT_FONTS);
      if (document.fonts && document.fonts.ready) {
        await document.fonts.ready;
      }

      // Yeni pencere aç
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        alert('Pop-up engelleyici aktif. Lütfen pop-up\'lara izin verin.');
        return;
      }

      // İçeriği yeni pencereye kopyala
      const content = componentRef.current.innerHTML;
      const styles = Array.from(document.styleSheets)
        .map(styleSheet => {
          try {
            return Array.from(styleSheet.cssRules)
              .map(rule => rule.cssText)
              .join('\n');
          } catch (e) {
            return '';
          }
        })
        .join('\n');

      // Font stillerini ekle
      const fontStyles = `
        /* Temel Fontlar */
        @font-face {
          font-family: 'PdfSafe';
          src: url('${PdfSafeWoff2}') format('woff2');
          font-weight: 400;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'Arial Unicode MS';
          src: url('${ArialUnicodeMSOtf}') format('opentype');
          font-weight: 400;
          font-style: normal;
          font-display: swap;
        }
        
        /* ZaraH1Sans Ailesi */
        @font-face {
          font-family: 'ZaraH1Sans-Regular';
          src: url('${ZaraH1SansRegularWoff2}') format('woff2');
          font-weight: 400;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'ZaraH1Sans-Bold';
          src: url('${ZaraH1SansBoldWoff2}') format('woff2');
          font-weight: 700;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'ZaraH1Sans-Light';
          src: url('${ZaraH1SansLightWoff2}') format('woff2');
          font-weight: 300;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'ZaraH1Sans-Medium';
          src: url('${ZaraH1SansMediumWoff2}') format('woff2');
          font-weight: 500;
          font-style: normal;
          font-display: swap;
        }
        
        /* Arial Ailesi */
        @font-face {
          font-family: 'Arial-Regular';
          src: url('${ArialRegularTtf}') format('truetype');
          font-weight: 400;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'Arial-Bold';
          src: url('${ArialBoldTtf}') format('truetype');
          font-weight: 700;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'Arial-Italic';
          src: url('${ArialItalicTtf}') format('truetype');
          font-weight: 400;
          font-style: italic;
          font-display: swap;
        }
        
        /* Helvetica Ailesi */
        @font-face {
          font-family: 'Helvetica Neue LT Std';
          src: url('${HelveticaNeueLTStdCnWoff2}') format('woff2');
          font-weight: 400;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'Helvetica Neue LT Std Bold';
          src: url('${HelveticaNeueLTStdBdWoff2}') format('woff2');
          font-weight: 700;
          font-style: normal;
          font-display: swap;
        }
        
        /* Arial Narrow */
        @font-face {
          font-family: 'Arial-Narrow';
          src: url('${ArialNarrowTtf}') format('truetype');
          font-weight: 400;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'ArialNarrow';
          src: url('${ArialNarrowWoff2}') format('woff2');
          font-weight: 400;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: 'ArialNarrowBold';
          src: url('${ArialNarrowBoldWoff2}') format('woff2');
          font-weight: 700;
          font-style: normal;
          font-display: swap;
        }
      `;

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Etiket Print</title>
          <style>
            ${fontStyles}
            ${styles}
            ${pageStyle}
            @media print {
              html, body { margin: 0 !important; padding: 0 !important; }
              * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
            }
          </style>
        </head>
        <body>
          ${content}
        </body>
        </html>
      `);

      printWindow.document.close();
      
      // Print dialog'u aç - web yavaşlığı için süre artırıldı
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 1500);

    } catch (error) {
      console.error('Alternatif print hatası:', error);
      alert('Print işlemi başarısız oldu: ' + error.message);
    } finally {
      // Loading indicator'ı gizle
      setIsLoadingFonts(false);
    }
  }
  
  function TabContent({ data, selectColor, componentRef }) {
    if (!data || !data.referance) {
      return <div>Veri yükleniyor...</div>;
    }
    
    const labelWidth = data.referance.width;
    const labelHeight = data.referance.height;

    if (labelWidth === 60 && labelHeight === 25) {

      return <L60_25 data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;
    }
    if (labelWidth === 60 && labelHeight === 30) {
      return <L60_30 data={data} selectColor={selectColor} ref={componentRef} tab={tab}/>;
    }
    if (labelWidth === 60 && labelHeight === 40) {
      return <L60_40 data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;
    }

    if (labelWidth === 120 && labelHeight === 25) {
      return <L120_25New data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;
    }
    // Diğer durumlar için varsayılan bir içerik göster
    return <div>Bu boyuttaki etiketin tasarımı henüz hazır değil.</div>;
  }

  function TabContent2({ data, selectColor, componentRef }) {
    if (!data || !data.referance) {
      return <div>Veri yükleniyor...</div>;
    }

    const labelWidth = data.referance.width;
    const labelHeight = data.referance.height;
    if(zaratype === "ZaraHome"){

      if(gottypeprice){
        return <L55XPRHOMEH data={data} selectColor={selectColor} ref={componentRef} tab={tab} bicakIziParams={bicakIziParams} />;
      }else{
        return <L55XPRH data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;
      }
    }
    else{
      if(gottypeprice){
  
        return <L55XPRKNIFE data={data} selectColor={selectColor} ref={componentRef} tab={tab} bicakIziParams={bicakIziParams} />;
      
      }else{
      
        return <L55XPR data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;
      
      }
    }


  }

  function TabContent3({ data, selectColor, componentRef }) {
    if (!data || !data.referance) {
      return <div>Veri yükleniyor...</div>;
    }

    const labelWidth = data.referance.width;
    const labelHeight = data.referance.height;
if(gottypeprice){
  return <BeltKnifeMain data={data} selectColor={selectColor} ref={componentRef} tab={tab} bicakIziParams={bicakIziParams} />;
}else{
  if(zaratype === "ZaraHome"){
    return <BeltMainHome data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;
  }else{

  return <BeltMain data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;
  }
}

  }
  function TabContent4({ data, selectColor, componentRef }) {
    if (!data || !data.referance) {
      return <div>Veri yükleniyor...</div>;
    }

    const labelWidth = data.referance.width;
    const labelHeight = data.referance.height;
    if(zaratype === "ZaraHome"){
      return <BrandMainZaraHome data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;
    }else{
      return <BrandMain data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;
    }

  }
  function TabContent5({ data, selectColor, componentRef }) {
    if (!data || !data.referance) {
      return <div>Veri yükleniyor...</div>;
    }

    const labelWidth = data.referance.width;
    const labelHeight = data.referance.height;
    return <CordMain data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;

  }
  function TabContent6({ data, selectColor, componentRef }) {
    if (!data || !data.referance) {
      return <div>Veri yükleniyor...</div>;
    }

    const labelWidth = data.referance.width;
    const labelHeight = data.referance.height;
    return <AddionalMain data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;

  }

  function TabContent10({ data, selectColor, componentRef }) {

    
    if (!data || !data.referance) {
      return <div>Veri yükleniyor...</div>;
    }

    const labelWidth = data.referance.width;
    const labelHeight = data.referance.height;
    return <EkstraMain data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;

  }
  function TabContent7({ data, selectColor, componentRef }) {
    if (!data || !data.referance) {
      return <div>Veri yükleniyor...</div>;
    }

    const labelWidth = data.referance.width;
    const labelHeight = data.referance.height;
    return <EmptyMain data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;

  }
  function TabContent8({ data, selectColor, componentRef }) {
    if (!data || !data.referance) {
      return <div>Veri yükleniyor...</div>;
    }

    const labelWidth = data.referance.width;
    const labelHeight = data.referance.height;
    if(zaratype === "ZaraHome"){
      return <Label11Dynamic data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;
    }else{
      return <></>;
    }
  }
  function TabContent9({ data, selectColor, componentRef }) {
    if (!data || !data.referance) {
      return <div>Veri yükleniyor...</div>;
    }

    const labelWidth = data.referance.width;
    const labelHeight = data.referance.height;
    if(zaratype === "ZaraHome"){
      return <Label12Dynamic data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;
    }else{
      return <></>;
    }
  }
  function TabContent1({ data, selectColor, componentRef }) {
    if (!data || !data.referance) {
      return <div>Veri yükleniyor...</div>;
    }
    
    const labelWidth = data.referance.width;
    const labelHeight = data.referance.height;
    return <Warning_55_120 data={data} selectColor={selectColor} ref={componentRef} tab={tab} />;

  }

  if (isFetching) return <Spinner className="h-screen w-5" />
  
  if (isError) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Hata Oluştu</h2>
          <p className="text-gray-600 mb-4">
            {artworkError?.response?.data?.message || artworkError?.message || 'Bilinmeyen bir hata oluştu'}
          </p>
          <button 
            onClick={() => window.location.reload()} 
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Sayfayı Yenile
          </button>
        </div>
      </div>
    )
  }
  
  if (!data || !data.referance) {
    return <Spinner className="h-screen w-5" />
  }
  
  const labelHeight = data.referance.height
  const labelWidth = data.referance.width

  

  const department = data.brand.Department.find(
    (item) => item.name === data.department.split('/')[1].trim()
  )
  return (
    <div className="relative py-20 bg-gray-200">
      {/* Loading Indicator */}
      {isLoadingFonts && <LoadingIndicator />}

      <div className="absolute left-1/2 -translate-x-1/2 top-5 flex gap-x-2">
  

          {tab === 0 && data.washingLabel.length > 1 &&
    data.washingLabel.map((item, idx) => (
      <Button key={idx} variant="blue" size="sm" onClick={() => setSelectColor(idx)}>
        {idx + 1}.Renk ({item.colorCode})
      </Button>
    ))}
  {tab === 1 && data.warningLabel && data.warningLabel.length > 1 &&
    data.warningLabel.map((item, idx) => (
      <Button key={idx} variant="blue" size="sm" onClick={() => setSelectColor(idx)}>
        {idx + 1}.Renk ({item.colorCode})
      </Button>
    ))}
    {tab === 2 && data.priceLabel && data.priceLabel.length > 1 &&
    data.priceLabel.map((item, idx) => (
      <Button key={idx} variant="blue" size="sm" onClick={() => setSelectColor(idx)}>
        {idx + 1}.Renk ({item.colorCode})
      </Button>
    ))}
    {tab === 3 && data.beltLabel && data.beltLabel.length > 1 &&
    data.beltLabel.map((item, idx) => (
      <Button key={idx} variant="blue" size="sm" onClick={() => setSelectColor(idx)}>
        {idx + 1}.Renk ({item.colorCode})
      </Button>
    ))}
    {tab === 4 && data.brandLabel && data.brandLabel.length > 1 &&
    data.brandLabel.map((item, idx) => (
      <Button key={idx} variant="blue" size="sm" onClick={() => setSelectColor(idx)}>
        {idx + 1}.Renk ({item.colorCode})
      </Button>
    ))}
    {tab === 5 && data.cordLabel && data.cordLabel.length > 1 &&
    data.brandLabel.map((item, idx) => (
      <Button key={idx} variant="blue" size="sm" onClick={() => setSelectColor(idx)}>
        {idx + 1}.Renk ({item.colorCode})
      </Button>
    ))}
    {tab === 6 && data.addionalLabel && data.addionalLabel.length > 1 &&
    data.brandLabel.map((item, idx) => (
      <Button key={idx} variant="blue" size="sm" onClick={() => setSelectColor(idx)}>
        {idx + 1}.Renk ({item.colorCode})
      </Button>
    ))}
      </div>
      <div className="absolute top-5 right-5 flex gap-x-2">
        <Link
          to={`/siparisler/ekle/${data.brand.id}_${data.brand.name}/${department.id}_${
            department.name
          }/${data.department.split('/')[2].trim()}/${orderNo}`}
        >
          <Button size="sm">
            <FileSignature size={20} className="mr-2" />
            Düzenle
          </Button>
        </Link>
        <div style={{display:'none'}}>    <Button variant="green" className="flex gap-x-2" size="sm" onClick={exportPDF}>
          <FileSignature size={20} className="mr-2" />
          PDF Olarak İndir
        </Button></div>
        <Button 
          variant="blue" 
          size="sm" 
          className="flex gap-x-2" 
          onClick={handleAlternativePrint}
          disabled={isPrinting}
        >
          <FileDown size={20} /> Alternatif Print
        </Button>

        <Button
          type="button"
          variant="green"
          size="sm"
          className="flex gap-x-2"
          onClick={handlePrint}
          disabled={isPrinting}
        >
          <FileDown size={20} /> Pdf olarak kaydet
        </Button>


        {isLoading && <p>PDF Oluşturuluyor...</p>}
        {pdfError && <p>Hata: {pdfError.message}</p>}
        {pdfUrl && (
          <iframe
            src={pdfUrl}
            style={{ width: '100%', height: '500px' }}
            title="PDF Preview"
          ></iframe>
        )}
      </div>
      {tab === 0 && (
        <TabContent data={data} selectColor={selectColor} componentRef={componentRef}/>
      )}
      {tab === 1 && (
        <TabContent1 data={data} selectColor={selectColor} componentRef={componentRef} />
      )}
      {tab === 2&& (
        <TabContent2 data={data} selectColor={selectColor} componentRef={componentRef} />
      )}
      {tab === 3&& (
        <TabContent3 data={data} selectColor={selectColor} componentRef={componentRef} />
      )}
      {tab === 4&& (
        <TabContent4 data={data} selectColor={selectColor} componentRef={componentRef} />
      )}
      {tab === 5&& (
        <TabContent5 data={data} selectColor={selectColor} componentRef={componentRef} />
      )}
      {tab === 6&& (
        <TabContent6 data={data} selectColor={selectColor} componentRef={componentRef} />
      )}
      {tab === 7&& (
        <TabContent7 data={data} selectColor={selectColor} componentRef={componentRef} />
      )}
      {tab === 8&& (
        <TabContent8 data={data} selectColor={selectColor} componentRef={componentRef} />

      )}
      {tab === 9 && (
        <TabContent9 data={data} selectColor={selectColor} componentRef={componentRef} />
      )}
      {(tab === 10 || tab === "10" || Number(tab) === 10) && (
        <TabContent10 data={data} selectColor={selectColor} componentRef={componentRef} />
      )}
    </div>
  )
}
